import React from 'react';
import { SalaryPreviewTable, SalaryPreviewTableData } from './SalaryPreviewTable';
import { useQuery } from 'react-query';
import api from 'api';
import { componentNames } from './constants';

export const DefaultSalaryStructurePreview = () => {
  const { isLoading, isFetching, data } = useQuery({
    queryFn: api.employeeOnboarding.fetchSalaryPreview,
  });

  const tableData: SalaryPreviewTableData[] = [
    {
      id: 'basic',
      name: componentNames.basic,
      monthlyAmount: data?.data?.salaryStructure?.basic || 0,
      annualAmount: (data?.data?.salaryStructure?.basic || 0) * 12,
    },
    {
      id: 'hra',
      name: componentNames.hra,
      monthlyAmount: data?.data?.salaryStructure?.hra || 0,
      annualAmount: (data?.data?.salaryStructure?.hra || 0) * 12,
    },
    {
      id: 'sa',
      name: componentNames.sa,
      monthlyAmount: data?.data?.salaryStructure?.specialAllowance || 0,
      annualAmount: (data?.data?.salaryStructure?.specialAllowance || 0) * 12,
    },
    {
      id: 'lta',
      name: componentNames.lta,
      monthlyAmount: data?.data?.salaryStructure?.lta || 0,
      annualAmount: (data?.data?.salaryStructure?.lta || 0) * 12,
    },
  ];
  if (data?.data?.contributions?.esi?.totalContribution) {
    tableData.push({
      id: 'esi',
      name: componentNames.esi,
      monthlyAmount: data?.data?.contributions?.esi?.employerAmount || 0,
      annualAmount: (data?.data?.contributions?.esi?.employerAmount || 0) * 12,
    });
  }
  if (data?.data?.contributions?.pf?.totalContribution) {
    tableData.push({
      id: 'pf',
      name: componentNames.pf,
      monthlyAmount: data?.data?.contributions?.pf?.employerAmount || 0,
      annualAmount: (data?.data?.contributions?.pf?.employerAmount || 0) * 12,
    });
  }
  if (data?.data?.contributions?.lwf?.totalContribution) {
    tableData.push({
      id: 'lwf',
      name: componentNames.lwf,
      monthlyAmount: data?.data?.contributions?.lwf?.employerAmount || 0,
      annualAmount: (data?.data?.contributions?.lwf?.employerAmount || 0) * 12,
    });
  }
  const allowances = data?.data?.salaryStructure?.allowances;
  if (allowances && !Array.isArray(allowances)) {
    const customAllowancesKeys = Object.keys(allowances);
    customAllowancesKeys.forEach((key) => {
      const allowance = allowances[key];
      tableData.push({
        id: key,
        name: allowance.name,
        monthlyAmount: allowance.amount,
        annualAmount: allowance.amount * 12,
      });
    });
  }

  return <SalaryPreviewTable tableData={tableData} isLoading={isLoading || isFetching} />;
};
